import { render, staticRenderFns } from "./CampanhaPieChartCustom.vue?vue&type=template&id=25cb9c8d&scoped=true&"
import script from "./CampanhaPieChartCustom.vue?vue&type=script&lang=js&"
export * from "./CampanhaPieChartCustom.vue?vue&type=script&lang=js&"
import style0 from "./CampanhaPieChartCustom.vue?vue&type=style&index=0&id=25cb9c8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cb9c8d",
  null
  
)

export default component.exports